import {
  convertFromLenderUserDataToLenderUserResponse,
  convertFromLenderUserResponseToLenderUserData,
  ILenderUserData,
  ILenderUserResponse,
} from '../lenders/ILenderUser';
import { IPresentationContactData } from './IPresentationContactData';

// when Lender contacts requested from the order level are, the response has 'emailAddress' -- NOT 'email'.
export interface ILenderContactResponse extends Omit<ILenderUserResponse, 'email'> {
  emailAddress: string;
  lenderUser?: ILenderUserResponse;
}

export interface ILenderContactData extends ILenderUserData {
  lenderUser?: ILenderUserData;
}

export const convertFromLenderContactResponseToLenderContactData = (
  data: ILenderContactResponse
): ILenderContactData => ({
  ...data,
  email: data.emailAddress,
  lenderUser: data.lenderUser && convertFromLenderUserResponseToLenderUserData(data.lenderUser),
});

export const convertFromLenderContactDataToLenderContactResponse = (
  data: ILenderContactData
): ILenderContactResponse => ({
  ...data,
  emailAddress: data.email,
  lenderUser: data.lenderUser && convertFromLenderUserDataToLenderUserResponse(data.lenderUser),
});

export const convertFromLenderOrderContactResponseArrayToLenderContactDataArray = (
  responseArray: ILenderContactResponse[]
): ILenderContactData[] => responseArray.map(convertFromLenderContactResponseToLenderContactData);

export type IPresentationLenderContactData = IPresentationContactData<ILenderContactData, string>;
